(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["manahveda-cookie-consent"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  const STORAGE_KEY = 'analytics_consent';
  const banner = document.getElementById('mv-cookie-consent');
  const acceptButton = document.getElementById('mv-cookie-accept');
  const rejectButton = document.getElementById('mv-cookie-reject');

  if (!banner) return;

  function getConsent() {
    return window.localStorage.getItem(STORAGE_KEY);
  }

  function setConsent(value) {
    window.localStorage.setItem(STORAGE_KEY, value);
    window.manahvedaAnalyticsConsent = value;
  }

  function hideBanner() {
    banner.classList.add('is-hidden');
  }

  function showBanner() {
    banner.classList.remove('is-hidden');
  }

  window.manahvedaAnalyticsConsent = getConsent();

  if (getConsent()) {
    hideBanner();
    return;
  }

  window.setTimeout(showBanner, 500);

  if (acceptButton) {
    acceptButton.addEventListener('click', function () {
      setConsent('accepted');
      hideBanner();
    });
  }

  if (rejectButton) {
    rejectButton.addEventListener('click', function () {
      setConsent('rejected');
      hideBanner();
    });
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["manahveda-welcome-popup"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  const POPUP_DELAY_MS = 2000;
  const STORAGE_KEY = 'popupDismissed';
  const BANNER_CLASS = 'mv-announcement';
  const BANNER_VISIBLE_CLASS = 'is-visible';

  const popup = document.getElementById('manahveda-welcome-popup');
  if (!popup) return;

  const closeButton = document.getElementById('mv-popup-close');
  const isDismissed = sessionStorage.getItem(STORAGE_KEY) === 'true';

  function showBanner() {
    const banner = document.querySelector('.' + BANNER_CLASS);
    if (banner) banner.classList.add(BANNER_VISIBLE_CLASS);
  }

  function openPopup() {
    popup.hidden = false;
    document.body.style.overflow = 'hidden';
    window.requestAnimationFrame(function () {
      popup.classList.add('is-open');
    });
  }

  function closePopup() {
    popup.classList.remove('is-open');
    document.body.style.overflow = '';
    sessionStorage.setItem(STORAGE_KEY, 'true');

    window.setTimeout(function () {
      popup.hidden = true;
    }, 300);

    showBanner();
  }

  if (isDismissed) {
    showBanner();
  } else {
    window.setTimeout(openPopup, POPUP_DELAY_MS);
  }

  if (closeButton) {
    closeButton.addEventListener('click', closePopup);
  }

  popup.addEventListener('click', function (event) {
    if (event.target === popup) closePopup();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && popup.classList.contains('is-open')) {
      closePopup();
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
